/* Approved production navigation. Reinitializes after Shopify section updates. */
(() => {
  'use strict';
  const desktop = matchMedia('(min-width:951px)');
  const footerDesktop = matchMedia('(min-width:701px)');
  const normalizePath = value => value.replace(/\/$/, '') || '/';

  function closeMenu(header) {
    header.querySelector('.drx-shell-nav')?.classList.remove('is-open');
    const button = header.querySelector('.drx-shell-menu');
    button?.setAttribute('aria-expanded', 'false');
    button?.setAttribute('aria-label', 'Open navigation');
  }

  function closeDropdowns(header) {
    header.querySelectorAll('.drx-shell-drop[open]').forEach(details => { details.open = false; });
  }

  function setupHeader(scope = document) {
    scope.querySelectorAll('.drx-shell-header').forEach(header => {
      if (header.dataset.drxReady) return;
      const button = header.querySelector('.drx-shell-menu');
      const nav = header.querySelector('.drx-shell-nav');
      if (!button || !nav) return;
      header.dataset.drxReady = 'true';

      button.addEventListener('click', () => {
        const open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      });
      const dropdowns = [...header.querySelectorAll('.drx-shell-drop')];
      dropdowns.forEach(details => details.addEventListener('toggle', () => {
        if (details.open) dropdowns.forEach(other => { if (other !== details) other.open = false; });
      }));
      nav.addEventListener('click', event => {
        if (event.target.closest('a')) {
          closeMenu(header);
          closeDropdowns(header);
        }
      });

      const path = normalizePath(location.pathname);
      let activeGroup = null;
      header.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || normalizePath(url.pathname) !== path) return;
        link.setAttribute('aria-current', 'page');
        if (!activeGroup) {
          activeGroup = link.closest('.drx-shell-drop');
          activeGroup?.setAttribute('data-active', '');
        }
      });
    });
  }

  function setupFooter(scope = document) {
    scope.querySelectorAll('[data-drx-footer-group]').forEach(details => {
      details.open = footerDesktop.matches;
      const summary = details.querySelector('summary');
      if (footerDesktop.matches) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    });
  }

  document.addEventListener('click', event => {
    document.querySelectorAll('.drx-shell-header').forEach(header => {
      if (!header.contains(event.target)) closeDropdowns(header);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const header = document.querySelector('.drx-shell-header');
    if (!header) return;
    const open = header.querySelector('.drx-shell-drop[open]');
    if (open) {
      open.open = false;
      open.querySelector('summary').focus();
    } else if (header.querySelector('.drx-shell-nav.is-open')) {
      closeMenu(header);
      header.querySelector('.drx-shell-menu').focus();
    }
  });
  desktop.addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.drx-shell-header').forEach(closeMenu);
  });
  footerDesktop.addEventListener('change', () => setupFooter());
  document.addEventListener('shopify:section:load', event => {
    setupHeader(event.target);
    setupFooter(event.target);
  });
  setupHeader();
  setupFooter();
})();
